<style lang="less" scoped>
ul,li{
  list-style: none;
  margin: 0;
  padding: 0;
}
.my-books {
  width: 93%;
  min-height: 550px;
  margin: 0 auto;
  .loading {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .bookImg {
    width: 210px;
    text-align: center;
    padding-top: 20px;
    img {
      width: 160px;
      display: block;
      margin-left: 30px;
      border-radius: 8px;
    }
  }
  .bookSelect {
    width: 25%;
    float: left;
    left: 0%;

    .bookContent {
      width: 210px;
      line-height: 34px;
      text-align: center;
      color: #040506;
      font-size: 16px;
    }
    .buy {
      width: 200px;
      text-align: center;
      .ant-btn-primary {
        background-color: #ff9a4a;
        border-color: #ff9a4a;
      }
    }
  }
}
</style>

<template>
  <div class="my-books">
    <a-spin class="loading" v-show="loading" />
    <a-tabs default-active-key="1" size="large">
      <a-tab-pane key="1" tab="已获得教材" >
        <ul>
          <li class="bookSelect" v-for="(item,index) in myBookList1" :key="index">
            <div class="bookImg">
              <img :src="$resBasePath+item.path" alt="">
            </div>
            <div class="bookContent">{{item.name}}</div>
            <!-- <div class="bookContent" v-if="item.isBuy==1">{{item.volumeNum}}</div> -->
          </li>
        </ul>
        <div v-if="myBookList1.length == 0">
          <a-empty />
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="更多教材" force-render>
        <a-list :grid="{ gutter: 24, column: 3 }" :data-source="myBookList">
          <a-list-item class="bookSelect" slot="renderItem" slot-scope="item" v-if="item.isBuy==0">
            <div class="bookImg">
              <img :src="$resBasePath+item.photoPath" alt="">
            </div>
            <div class="bookContent" v-if="item.isBuy==0">{{item.name}}</div>
            <div class="buy" v-if="isBuyBtn" @click="buy(item)">
              <a-button v-if="item.isBuy==0" type="primary" icon="">购买</a-button>
            </div>
          </a-list-item>
        </a-list>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'my-books',
  data () {
    return {
      myBookList: [],
      myBookList1: [],
      moreBookList: [],
      loading: false,
      payForm: '',
      id: [], // productId 教材Id
      isBuyBtn: false
    }
  },
  methods: {
    getBuyBooks () {
      axios({
        url: this.$baseUrl + 'ebook/purchase/v2/purchaseIsOpen',
        param: {},
        method: 'GET'
      }).then(res => {
        // console.log('测试购买',res)
        this.isBuyBtn = res.data.resultData
      })
    },
    getMyBook () { // 获取我的教材
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/purchase/v2/getProducts',
        body: {
          userId: _this.$getUserInfo().id,
          tag: 2
        }
      }).loading(
        () => (_this.loading = true),
        () => (_this.loading = false)
      ).done(
        res => {
          if (res.resultCode == 0 && res.success === true) {
            _this.myBookList = res.resultData
            _this.myBookList1 = []
            _this.myBookList.forEach(item => {
              if (item.isBuy != 0) {
                _this.myBookList1.push({
                  name: item.name,
                  path: item.photoPath
                })
              }
            })
          }
        }
      )
    },
    getMoreList () { // 获取更多教材列表
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/book/list'
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(
        res => {
          if (res.resultCode == 0 && res.success === true) {
            _this.moreBookList = res.resultData.list
          }
        }
      )
    },
    buy (item) {
      // window._czc.push(['_trackEvent', '个人中心', '购买教材'])
      this.$fetch({
        url: this.$baseUrl + 'ebook/purchase/v2/webSaveBookOrder',
        body: {
          productId: item.id
        }
      }).done(res => {
        this.payForm = res.resultData.alipayOrderString
        this.$router.push({ name: 'BuyBook', params: { payUrl: res.resultData.alipayOrderString, product: item } })
      })
    }
  },
  mounted () {
    this.getMyBook()
    // this.getBuyBooks()
    // this.getMoreList()
  }
}
</script>
